import React, { memo } from 'react'
import { ConfirmationModal } from 'transfix-ui'

interface INeedPermissionModalProps {
  action: string
  contact: string
  open: boolean
  onClose: () => void
}

export const NeedPermissionModal = memo<INeedPermissionModalProps>(
  ({ action, contact, onClose, open }) => (
    <ConfirmationModal
      title='You need permission'
      size={6}
      open={open}
      actions={[{ label: 'Ok', type: 'confirm' }]}
      onClose={onClose}
      dataTest='need-permission'>
      <>
        You don’t have permission to {action}. Please contact {contact}.
      </>
    </ConfirmationModal>
  )
)
